import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import LaunchAreaNotificationModal from './LaunchAreaNotificationModal';

import qmStyles from '../../theme/qmStyles';

const LaunchAreaNotificationButton = ({ payload }) => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <React.Fragment>
      <Button
        type="button"
        borderColor={qmStyles.qmBabyGreen}
        textColor={qmStyles.qmBabyGreen}
        text="Notify Me"
        onClick={() => {
          setModalOpen(true);
        }}
      />
      <LaunchAreaNotificationModal
        isOpen={modalOpen}
        closeModal={() => {
          setModalOpen(false);
        }}
        payload={payload}
      />
    </React.Fragment>
  );
};

LaunchAreaNotificationButton.propTypes = {
  payload: PropTypes.object.isRequired,
};

export default LaunchAreaNotificationButton;
